import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-right-up.svg'


const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "underline" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "open"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.link,
      target: "_blank",
      class: "flex flex-row text-white"
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1),
      _hoisted_4
    ], 8, _hoisted_2)
  ]))
}